import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import { rem } from 'polished'
import * as React from 'react'
import styled from 'styled-components'
import NavBarButtonBase from '../NavBarButton/NavBarButtonBase'

const Item = styled(NavBarButtonBase)`
  padding: 0 ${rem(12)};
  height: ${rem(48)};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${rem(4)};
`

interface Props extends React.ComponentProps<typeof NavBarButtonBase> {
  dropdown?: boolean
}

const NavBarMenuItem = React.forwardRef<HTMLButtonElement, Props>(function NavBarMenuItem(props, ref) {
  const { children, dropdown, ...buttonProps } = props

  return <Item {...buttonProps} ref={ref}>
    {children}
    {dropdown && <LineAngleDownIcon size="XS" />}
  </Item>
})

export default NavBarMenuItem
